/* eslint-disable-next-line no-restricted-imports */
import type { Id } from '@jane/shared/models';

const baseKey = ['store'];
export const queryKeys = {
  commsBanner: (storeId: Id) => [...baseKey, 'commsBanner', String(storeId)],
  seo: (storeId: Id) => [...baseKey, 'seo', String(storeId)],
  store: (storeId: Id) => [...baseKey, String(storeId)],
};

export const urls = {
  commsBanner: (storeId: Id) => `/stores/${storeId}/banner_message_settings`,
  seo: (storeId: Id) => `/stores/${storeId}/seo`,
  store: (storeId: Id) => `/stores/${storeId}`,
};
